// LEGACY — superseded by features/client-contacts/api/client.ts. Scheduled for deletion in 2 sprints.
import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { ClientContactItem } from "../interfaces/ClientContact";
import { ClientContactsResponse } from "../slices/clientContacts/types";
import { DEFAULT_PAGE_SIZE } from "../common/constants";

const api = new APIClient();

// Check if we should use the fake backend
export const getAllClientContacts = (
    pageNumber: number = 1,
    pageSize: number = DEFAULT_PAGE_SIZE
): Promise<ClientContactsResponse> => {
    
    // Real API call with query parameters - typed response
    return api.get<ClientContactsResponse>(url.GET_CLIENT_CONTACTS, {
        pageNumber,
        pageSize,
    });
};

export const createClientContact = (data: Partial<ClientContactItem>): Promise<ClientContactItem> => {
    
    // Clean payload for backend - only required fields
    const payload = {
        clientId: data.clientId,
        tenantId: data.tenantId,
        title: data.title,
        contactFirstName: data.contactFirstName,
        contactLastName: data.contactLastName,
        email: data.email,
        workPhone: data.workPhone,
        mobile: data.mobile,
        notes: data.notes,
        isAllowPortalAccess: data.isAllowPortalAccess || false,
    };
    return api.create<ClientContactItem>(url.ADD_NEW_CLIENT_CONTACT, payload);
};

export const updateClientContact = (
    id: string,
    data: Partial<ClientContactItem>
): Promise<ClientContactItem> => {
    
    // PUT payload must include these fields
    const payload = {
        title: data.title,
        contactFirstName: data.contactFirstName,
        contactLastName: data.contactLastName,
        email: data.email,
        workPhone: data.workPhone,
        mobile: data.mobile,
        notes: data.notes,
        isAllowPortalAccess: data.isAllowPortalAccess || false,
    };
    return api.put<ClientContactItem>(url.UPDATE_CLIENT_CONTACT + "/" + id, payload);
};

export const deleteClientContact = (id: string): Promise<void> => {
    
    return api.delete<void>(url.DELETE_CLIENT_CONTACT + "/" + id);
};
